import api from './api';
import { VocabularyCard, VocabularyCardCreate, CardReviewRequest, DueCardsResponse, SRSStats } from '../types';

export const vocabularyService = {
  async createCard(data: VocabularyCardCreate): Promise<VocabularyCard> {
    const response = await api.post('/vocabulary/cards', data);
    return response.data;
  },

  async createBulkCards(cards: VocabularyCardCreate[]): Promise<VocabularyCard[]> {
    const response = await api.post('/vocabulary/cards/bulk', cards);
    return response.data;
  },

  async getAllCards(category?: string, difficulty?: string): Promise<VocabularyCard[]> {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (difficulty) params.append('difficulty', difficulty);
    
    const response = await api.get(`/vocabulary/cards?${params.toString()}`);
    return response.data;
  },

  async getDueCards(limit: number = 20): Promise<DueCardsResponse> {
    const response = await api.get(`/vocabulary/cards/due?limit=${limit}`);
    return response.data;
  },

  async reviewCard(data: CardReviewRequest): Promise<void> {
    await api.post('/vocabulary/review', data);
  },

  async getStats(): Promise<SRSStats> {
    const response = await api.get('/vocabulary/stats');
    return response.data;
  },

  async deleteCard(id: number): Promise<void> {
    await api.delete(`/vocabulary/cards/${id}`);
  }
};
